// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--LH37u","video":"video--HRPm5"};